import React from "react";

const Dashboard = () => {
  return <div></div>;
};

export default Dashboard;
